import { makeStyles } from 'tss-react/mui';

export const useDataTableStyles = makeStyles({ name: 'DataTable' })(theme => ({
  longText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  /* grid columns */
  columnHeader: {
    borderTop: 'none',
    color: theme.palette.text.secondary,
  },
  column: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[100]}`,
  },
  columnTwo: {
    paddingLeft: theme.spacing(2),
  },
  withPaddingRight: {
    paddingRight: theme.spacing(2),
  },

  /* three columns grid table */
  tableContainerWithThreeColumns: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) max-content max-content',
  },

  /* two columns grid table */
  tableContainerWithTwoColumns: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) max-content',
  },
}));
